import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { User } from '../../../core/models/user.model';
import { AuthenticationService } from '../../../login/services/authentication.service';
import { Router } from '@angular/router';
import { EventCertificatePlatform } from 'src/app/shared/models/eventCertificatePlatform.model';
import { CertificateService } from 'src/app/certificate/services/certificate.service';

@Component({
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  user: User;
  platformFooterHtml: SafeHtml;

  constructor(
    private authenticationService: AuthenticationService,
    private certificateService: CertificateService,
    private router: Router,
    private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.user = this.authenticationService.currentUserValue;

    this.certificateService.getEventCertificatePlatform().subscribe((data: EventCertificatePlatform) => {
      this.platformFooterHtml = this.sanitizer.bypassSecurityTrustHtml(data.platformFooterHtml);
    });
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }
}
